import { useDispatch } from 'react-redux';

import { DealProduct } from '../types';
import Alert from '../../../shared/components/Alert/Alert';
import { updateDealProductQuantity } from '../slice';

export default function useDealProduct(dealProduct: DealProduct) {
  const { no, name, maxEa, minEa } = dealProduct;

  const dispatch = useDispatch();

  const changeQuantity = (newQuantity: number) => {
    if (maxEa < newQuantity) {
      Alert({
        title: '알림',
        text: `${name}의 \n최대 수량은 ${maxEa}개까지 가능합니다.`,
      });
      return;
    }

    dispatch(updateDealProductQuantity({
      targetProductNo: no,
      quantity: newQuantity < minEa ? minEa : newQuantity,
    }));
  };

  const deselect = () => {
    dispatch(updateDealProductQuantity({
      targetProductNo: no,
      quantity: 0,
    }));
  };

  return { changeQuantity, deselect };
}
